import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import {
  AllocationSheetsServiceProxy,
  AllocationSheetViewDto,
} from '@shared/service-proxies/service-proxies';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';

@Component({
  selector: 'app-allocation-conditions',
  templateUrl: './allocation-conditions.component.html',
  styleUrls: ['./allocation-conditions.component.less'],
})
export class AllocationConditionsComponent
  extends AppComponentBase
  implements OnInit {
  @Input() allocationSheetId;
  @Output() onSetHeader: EventEmitter<any> = new EventEmitter<any>();

  sheetLoading = false;
  sheetData: AllocationSheetViewDto;

  constructor(
    injector: Injector,
    private _activatedRoute: ActivatedRoute,
    private _allocationSheetsServiceProxy: AllocationSheetsServiceProxy
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.getAllocationSheetForEdit({});
  }

  getAllocationSheetForEdit(evt) {
    this.sheetLoading = true;
    this._allocationSheetsServiceProxy
      .getAllocationSheetForEdit(this.allocationSheetId)
      .subscribe((data) => {
        abp.event.trigger(
          'app.evt.allocationSheetUpdateButtonStatus',
          data.allocationSheet.allRequiredConditionsSpecified
        );

        if (evt && evt.onlyStatusEmit) {
          return;
        }

        this.sheetLoading = false;
        this.sheetData = data.allocationSheet;
        const headerText = `${data.allocationSheet.shortNumber} ${data.allocationSheet.ownerContactDetails.firstName} ${data.allocationSheet.ownerContactDetails.lastName} ${moment(data.allocationSheet.lastStatusUpdateDate).format('DD/MM/YY')}`
        this.onSetHeader.emit(headerText);

        abp.event.trigger('evt.allocationSheetStatusDataUpdate', {
          date: data.allocationSheet.lastStatusUpdateDate,
          status: data.allocationSheet.status,
          reason: data.allocationSheet.reason,
        });
      });
  }
}
